// extracted by mini-css-extract-plugin
module.exports = {"container":"NewsFeed_container__2Lf2g","list":"NewsFeed_list__2VFnA","withoutDataPlaceholder":"NewsFeed_withoutDataPlaceholder__1EU8b"};